export const ServiceActivityType = {
    answer: 'answer',
    assessment: 'assessment',
    consultation: 'consultation',
    evaluation: 'evaluation',
    examination: 'examination',
    inquiry: 'inquiry',
    question: 'question',
    referral: 'referral',
    unknown: 'unknown',
} as const;

export type ServiceActivityType = (typeof ServiceActivityType)[keyof typeof ServiceActivityType];
